import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './TrialBanner.css';

const TrialBanner = () => {
  const [accountStatus, setAccountStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchAccountStatus();
  }, []);

  const fetchAccountStatus = async () => {
    if (!token) return;

    try {
      const response = await axios.get(
        'https://bank-converter-app-3.onrender.com/account-status',
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setAccountStatus(response.data);
    } catch (error) {
      console.error('Failed to fetch account status:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !accountStatus) return null;

  const { trial_status, is_premium, active_devices, max_devices } = accountStatus;

  // Don't show banner for premium users with valid subscription
  if (is_premium && trial_status.valid) return null;

  // Show warning if trial is ending soon or expired
  const showWarning = trial_status.days_remaining <= 3 || !trial_status.valid;

  return (
    <div className={`trial-banner ${showWarning ? 'warning' : 'info'}`}>
      <div className="trial-content">
        <div className="trial-info">
          {!trial_status.valid ? (
            <>
              <span className="trial-icon">⚠️</span>
              <span className="trial-text">
                <strong>Trial Expired</strong> - Upgrade to Premium to continue using the app
              </span>
            </>
          ) : (
            <>
              <span className="trial-icon">⏰</span>
              <span className="trial-text">
                <strong>Trial:</strong> {trial_status.days_remaining} day{trial_status.days_remaining !== 1 ? 's' : ''} remaining
              </span>
            </>
          )}
        </div>

        <div className="device-info">
          <span className="device-icon">📱</span>
          <span className="device-text">
            Devices: {active_devices}/{max_devices}
          </span>
        </div>

        <button className="upgrade-btn-banner" onClick={() => window.location.href = '#/settings?tab=billing'}>
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default TrialBanner;